module.exports = __webpack_public_path__ + "assets/img/icon_refresh.503463c0.svg";